import { render } from "./MainView.vue?vue&type=template&id=20a8f83d&scoped=true&ts=true"
import script from "./MainView.vue?vue&type=script&lang=ts"
export * from "./MainView.vue?vue&type=script&lang=ts"

import "./MainView.vue?vue&type=style&index=0&id=20a8f83d&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a8f83d"]])

export default __exports__